import AdminInput from "../../components/AdminInput";
import { useTranslation } from "react-i18next";

const BusinessInformation = ({
    loading,
    data
}) => {
    const { t } = useTranslation();
    return (
        <div className="card-body px-4">
            <h5 className="account-section-title py-2">Business Information</h5>
            <hr className="hr-grey-account" />
            <div className="row d-flex align-items-start justify-content-between">
                <div className="col-12 col-lg-10">
                    <div className="row d-flex align-items-start justify-content-start mb-3">
                        <div className="col-5 col-lg-3">
                            <p className="account-text-label mb-0">
                                Business Name
                            </p>
                        </div>
                        <div className="col-7 col-lg-9">
                            <p className="account-text-value mb-0">
                                {data?.businessDetail?.businessInformation?.businessName}
                            </p>
                        </div>
                    </div>
                    <div className="row d-flex align-items-start justify-content-start mb-3">
                        <div className="col-5 col-lg-3">
                            <p className="account-text-label mb-0">
                                Business Phone Number
                            </p>
                        </div>
                        <div className="col-7 col-lg-9">
                            <p className="account-text-value mb-0">
                                {`(${data?.businessDetail?.businessInformation?.businessPrefixNumber}) ${data?.businessDetail?.businessInformation?.businessPhoneNumber}`}
                            </p>
                        </div>
                    </div>
                    <div className="row d-flex align-items-start justify-content-start mb-3">
                        <div className="col-5 col-lg-3">
                            <p className="account-text-label mb-0">
                                Business Address
                            </p>
                        </div>
                        <div className="col-7 col-lg-9">
                            <p className="account-text-value mb-0">
                                {data?.businessDetail?.businessInformation?.businessAddress}
                            </p>
                        </div>
                    </div>
                    <div className="row d-flex align-items-start justify-content-start mb-3">
                        <div className="col-5 col-lg-3">
                            <p className="account-text-label mb-0">
                                Business Location
                            </p>
                        </div>
                        <div className="col-7 col-lg-9">
                            <p className="account-text-value mb-0">
                                {data?.businessDetail?.businessInformation?.businessLocInJapan ? "Within Japan" : "Outside Japan"}
                            </p>
                        </div>
                    </div>
                    <div className="row d-flex align-items-start justify-content-start mb-3">
                        <div className="col-5 col-lg-3">
                            <p className="account-text-label mb-0">
                                Business Industry
                            </p>
                        </div>
                        <div className="col-7 col-lg-9">
                            <p className="account-text-value mb-0">
                                {data?.businessDetail?.businessInformation?.businessIndustry}
                            </p>
                        </div>
                    </div>
                    <div className="row d-flex align-items-start justify-content-start mb-3">
                        <div className="col-5 col-lg-3">
                            <p className="account-text-label mb-0">
                                Business Type
                            </p>
                        </div>
                        <div className="col-7 col-lg-9">
                            <p className="account-text-value mb-0">
                                {data?.businessDetail?.businessInformation?.businessType}
                            </p>
                        </div>
                    </div>
                    <div className="row d-flex align-items-start justify-content-start mb-3">
                        <div className="col-5 col-lg-3">
                            <p className="account-text-label mb-0">
                                Business Registration Number
                            </p>
                        </div>
                        <div className="col-7 col-lg-9">
                            <p className="account-text-value mb-0">
                                {data?.businessDetail?.businessInformation?.businessRegistrationNumber}
                            </p>
                        </div>
                    </div>
                    <div className="row d-flex align-items-start justify-content-start mb-3">
                        <div className="col-5 col-lg-3">
                            <p className="account-text-label mb-0">
                                Association Membership Number (e.g., IATA, ANTA)
                            </p>
                        </div>
                        <div className="col-7 col-lg-9">
                            <p className="account-text-value mb-0">
                                {data?.businessDetail?.businessInformation?.businessIataNumber || "-"}
                            </p>
                        </div>
                    </div>
                    <div className="row d-flex align-items-start justify-content-start mb-3">
                        <div className="col-5 col-lg-3">
                            <p className="account-text-label mb-0">
                                Business Website
                            </p>
                        </div>
                        <div className="col-7 col-lg-9">
                            <p className="account-text-value mb-0">
                                {data?.businessDetail?.businessInformation?.businessWebsite || "-"}
                            </p>
                        </div>
                    </div>
                </div>
                {
                    false && (
                        <div className="col-12 col-lg-2 d-flex align-items-start justify-content-end">
                            <button
                                type="button"
                                className="btn btn-edit-account px-2 py-2 mt-2 mt-lg-0"
                                onClick={() => { }}
                            >
                                {t("myPage.accountInformation.subMenu.businessInformation.button")}
                            </button>
                        </div>
                    )
                }
            </div>
        </div>
    );
};

export default BusinessInformation;
